import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";

const initialStateValue = {
    activeTab: 'sales',
    reportRange: 'lastWeek',
    salesInsights: {
        salesInsights: {},
        loading: 'idle',
        error: null,
    },
    productsInsights: {
        productsInsights: {},
        loading: 'idle',
        error: null,
    },
    lensInsights: {
        lensInsights: {},
        loading: 'idle',
        error: null,
    },
    couponsInsights: {
        couponsInsights: {},
        loading: 'idle',
        error: null,
    },
    agedInventory: {
        agedInventory: {},
        loading: 'idle',
        error: null,
    },
    lowInventoryProducts: {
        lowInventoryProducts: [],
        loading: 'idle',
        error: null,
    }
}

const fetchSalesInsights = createAsyncThunk('orders/fetchSalesInsights', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/sales`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const fetchProductsInsights = createAsyncThunk('orders/fetchProductsInsights', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/products`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const fetchAgedInventory = createAsyncThunk('orders/fetchAgedInventory', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/products/agedInventory`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const fetchLowInventoryProducts = createAsyncThunk('orders/fetchLowInventoryProducts', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/products/lowInventoryProducts`);
        return response.data.data.lowInventoryProducts;
    }
    catch(error) {
        throw error;
    }
});

const fetchCouponsInsights = createAsyncThunk('orders/fetchCouponsInsights', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/coupons`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const fetchLensInsights = createAsyncThunk('orders/fetchLensInsights', async () => {
    try {
        const response = await apiV1.get(`reportAndAnalysis/lens`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const reportAnalysisSlice = createSlice({
    name: 'reportAnalysis',
    initialState: initialStateValue,
    reducers: {
        changeTab: (state, action) => {
            state.activeTab = action.payload;
        },
        changeReportRange: (state, action) => {
            state.reportRange = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchSalesInsights.pending, (state) => {
            state.salesInsights.loading = 'loading';
        })
        .addCase(fetchSalesInsights.fulfilled, (state, action) => {
            state.salesInsights.loading = 'succeeded';
            state.salesInsights.salesInsights = action.payload;
        })
        .addCase(fetchSalesInsights.rejected, (state, action) => {
            state.salesInsights.loading = 'failed';
            state.salesInsights.error = action.error.message;
        })
        .addCase(fetchProductsInsights.pending, (state) => {
            state.productsInsights.loading = 'loading';
        })
        .addCase(fetchProductsInsights.fulfilled, (state, action) => {
            state.productsInsights.loading = 'succeeded';
            state.productsInsights.productsInsights = action.payload;
        })
        .addCase(fetchProductsInsights.rejected, (state, action) => {
            state.productsInsights.loading = 'failed';
            state.productsInsights.error = action.error.message;
        })
        .addCase(fetchCouponsInsights.pending, (state) => {
            state.couponsInsights.loading = 'loading';
        })
        .addCase(fetchCouponsInsights.fulfilled, (state, action) => {
            state.couponsInsights.loading = 'succeeded';
            state.couponsInsights.couponsInsights = action.payload;
        })
        .addCase(fetchCouponsInsights.rejected, (state, action) => {
            state.couponsInsights.loading = 'failed';
            state.couponsInsights.error = action.error.message;
        })
        .addCase(fetchLensInsights.pending, (state) => {
            state.lensInsights.loading = 'loading';
        })
        .addCase(fetchLensInsights.fulfilled, (state, action) => {
            state.lensInsights.loading = 'succeeded';
            state.lensInsights.lensInsights = action.payload;
        })
        .addCase(fetchLensInsights.rejected, (state, action) => {
            state.lensInsights.loading = 'failed';
            state.lensInsights.error = action.error.message;
        })
        .addCase(fetchAgedInventory.pending, (state) => {
            state.agedInventory.loading = 'loading';
        })
        .addCase(fetchAgedInventory.fulfilled, (state, action) => {
            state.agedInventory.loading = 'succeeded';
            const result = action.payload
            state.agedInventory.agedInventory = result?.product;
        })
        .addCase(fetchAgedInventory.rejected, (state, action) => {
            state.agedInventory.loading = 'failed';
            state.agedInventory.error = action.error.message;
        })
        .addCase(fetchLowInventoryProducts.pending, (state) => {
            state.lowInventoryProducts.loading = 'loading';
        })
        .addCase(fetchLowInventoryProducts.fulfilled, (state, action) => {
            state.lowInventoryProducts.loading = 'succeeded';
            state.lowInventoryProducts.lowInventoryProducts = action.payload;
        })
        .addCase(fetchLowInventoryProducts.rejected, (state, action) => {
            state.lowInventoryProducts.loading = 'failed';
            state.lowInventoryProducts.error = action.error.message;
        })
    },
});

export const {
    changeTab,
    changeReportRange,
} = reportAnalysisSlice.actions;

export {
    fetchSalesInsights,
    fetchProductsInsights,
    fetchCouponsInsights,
    fetchLensInsights,
    fetchAgedInventory,
    fetchLowInventoryProducts
}

export default reportAnalysisSlice.reducer;
